import { Injectable, signal } from '@angular/core';

// Apis
import { ClubECardApi } from '@core/api/club/ecard.api';

// Models
import { ECardData } from '@core/models/club/ecard.model';

/**
 * Service e-card — met en cache la carte associée à une clé publique.
 */
@Injectable({ providedIn: 'root' })
export class ClubECardService {
	readonly data = signal<ECardData | null>(null);
	readonly loading = signal(false);

	private currentKey?: string;

	constructor(private api: ClubECardApi) {}

	load(key: string): void {
		if (!key || this.loading()) return;
		if (this.data() && this.currentKey === key) return;

		this.currentKey = key;
		this.loading.set(true);
		this.api.query(key).subscribe({
			next: (response) => {
				this.data.set({
					cardData: response.data,
					photo: response.photo,
					qrcode: response.qrcode,
				});
				this.loading.set(false);
			},
			error: (err: any) => {
				console.error('Erreur chargement e-card', err);
				this.loading.set(false);
			},
		});
	}

	reload(key = this.currentKey!): void {
		this.data.set(null);
		this.load(key);
	}
}
